module.exports = {
  container: {
    title: '軽量、オープン、セキュアな Web3 インフラストラクチャ プラットフォーム',
    content:
      'BitFlow は、安定性、信頼性、安全性の高いブロックチェーン インフラストラクチャを構築し、ネットワーク全体で主流のパブリック チェーン ノードを集約し、便利な LSD プレッジ サービスを提供し、デジタル資産の安定性と流動性を維持することを目指しています。',
    info: 'ネットワーク: 10 社以上 パートナー: 20 名以上 コミュニティ ユーザー: 20,000 名以上',
    button: '即時ステーキング',
  },
  intro: {
    title: 'BitFlow コア機能',
    coinTitle1: '非保管ステーキング',
    coinContent1:
      '分散ノードを通じて、ユーザー資産はユーザー自身のウォレットに保存され、BitFlow は検証キーのみを保持し、ユーザーの出金キーには触れません。',
    coinTitle2: '流動性コミットメント',
    coinContent2:
      '安全で便利な流動性ステーキングサービスを提供し、多様なオラクルを利用して各種分散型取引所から流動性を得て、価格安定を維持します。',
    coinTitle3: 'LSO',
    coinContent3:
      'Pledge はマイニングであり、新しいトークンファイナンスモデルです。ユーザーはトークンをプレッジしてプラットフォームにロックするだけでマイニング収入を得ることができます。',
  },
  advantage: {
    title: 'ビットフローのハイライト',
    title2: '安全、効率的、信頼性の高いLSD誓約サービスを提供します',
    content:
      'BitFlow は、Web3、DeFi、暗号化金融の基本層として、グローバルな分散ノード インフラストラクチャを通じて、より協調的で強力なマルチチェーン エコシステムを構築し、ユーザーがリスク分散された自動管理および効率的な方法で LSD プレッジ サービスに参加できるようにします。デジタル資産を通じて世界をつなぎ、デジタルエコロジーアプリケーションの新時代を創造します。',
  },
  more: {
    title: '効率的で便利な革新的なモデル',
    content:
      'BitFlow を使用すると、ユーザーはステーキングされたトークンを使用して、BitFlow に統合された Web3 アプリケーションと DeFi サービスにアクセスし、探索できるようになります。',
    button: '詳細',
    boxTitle1: 'マルチチェーンプレッジ',
    boxContent1:
      '現在の協調型パブリック チェーンには ETH、BNB、Polygon、ARB、SUI などが含まれており、将来的にはさらに多くのネットワークがサポートされる予定です。',
    boxTitle2: '分散型',
    boxContent2:
      'プレッジユーザーとノードオペレーターは自由にマッチングされ、作成、引き出し、報酬の委任はすべて実行層のスマートコントラクトによって処理されます。',
    boxTitle3: 'ノード管理',
    boxContent3:
      'ユーザーがノード管理用に独自の検証ツールを導入できるようにサポートし、クラウド サービスのサポートを提供し、同期時間を節約します。',
    boxTitle4: 'ブロック監視',
    boxContent4:
      'BitFlow は、すべてのノードと API サービスを 24 時間リアルタイムで監視し、より包括的で直感的なデータをユーザーに提供します。',
    boxTitle5: '複利収入',
    boxContent5:
      'デジタル資産の流動性を解放するために、ユーザーはステーキング、流動性マイニング、招待リベートから複数のメリットを得ることができます。',
  },
  ecology: {
    title: '未来を約束する BitFlow エコシステム',
    content: 'Web3 アプリケーションのシナリオと DeFi サービスを探索する',
  },
  media: 'グローバルパートナー',
  bitFlowIntro: {
    content:
      '世界初の分散型スパイラル永久運動メカニズムの完璧なトークンエコノミーモデルで、持続可能な現金自動預け払い機を生産するための分散型かつ分散型の最強の Web3 インフラストラクチャ プラットフォームを作成します。',
  },
  transaction: {
    wallet: 'ウォレットへのログイン',
    assets: {
      title: '私の計算能力',
      content: '私の計算能力',
      text1: 'デポジット',
      text2: 'トレード',
      text3: '移行',
      text4: '置換',
      text5: '資産',
    },
    place: {
      tab1: '注文する',
      tab2: '双掷',
      text1: 'USDT残高',
      text2: 'FLOW残高',
      mask: '上位レベルのウォレットをバインドしていないため注文できません。',
      maskLight: 'すぐにバインドしますか?',
      payNeed: '支払いが必要です',
      confirm: '注文を確認する',
      contact: 'お問い合わせ',
      maskInputTitle: 'アカウントをリンクする',
      maskInputContent: '有効なアカウントがリンクされている場合にのみ、リンクが成功します。',
      placeholder: '有効なリンクされたアカウントを入力してください',
      confirmLink: 'リンクを確認する',
    },
  },
}
